export default function DomHelpers ()
{
  this.$ = (id, win = window) =>
  {
    return win.document.getElementById(id);
  };


  const setNodeLevelAttr = (element, level) =>
  {
    while (element)
    {
      while (element && element.nodeType !== 1)
      {
        element = element.nextSibling;
      }

      if (element)
      {
        element.setAttribute('nodeLevel', level, 0);

        if (element.firstChild)
        {
          setNodeLevelAttr(element.firstChild, level + 1);
        }

        element = element.nextSibling;
      }
    }
  };


  this.parseHTML = (container, args = {}) =>
  {
    let i,
        n,
        id,
        key,
        idPrefix = (args.idPrefix != null) ? args.idPrefix : 'id',
        idPostfix = (args.idPostfix != null) ? args.idPostfix : 'id',
        strParseTags,
        parseTags,
        strClasses,
        parseClasses,
        structure = args.structure || {},
        isParseClasses = args.isParseClasses || false,
        isSetLevel = args.isSetLevel || false,
        elements = container.getElementsByTagName('*');

    if (!('parseTags' in structure))
    {
      structure.parseTags = {};
    }

    if (isParseClasses && !('parseClasses' in structure))
    {
      structure.parseClasses = {};
    }

    for (i = elements.length; i--;)
    {
      id = elements[i].id;

      if ((idPrefix != null && id.indexOf(idPrefix) === 0) || (idPostfix != null && id.indexOf(idPostfix) === id.length - idPostfix.length))
      {
        key = id.slice(idPrefix.length, idPrefix.length + 1).toLowerCase() + id.slice(idPrefix.length + 1, -1 - idPostfix.length);
        structure[key] = elements[i];
      }

      strParseTags = elements[i].getAttribute('parseTags', 0);

      if (strParseTags)
      {
        parseTags = strParseTags.split(/\s+/);

        for (n = parseTags.length; n--;)
        {
          if (!(parseTags[n] in structure.parseTags))
          {
            structure.parseTags[parseTags[n]] = [];
          }

          structure.parseTags[parseTags[n]].push(elements[i]);
        }
      }

      if (isParseClasses)
      {
        strClasses = elements[i].getAttribute('class', 0);

        if (strClasses)
        {
          parseClasses = strClasses.split(/\s+/);

          for (n = parseClasses.length; n--;)
          {
            if (!(parseClasses[n] in structure.parseClasses))
            {
              structure.parseClasses[parseClasses[n]] = [];
            }

            structure.parseClasses[parseClasses[n]].push(elements[i]);
          }
        }
      }
    }

    if (isSetLevel)
    {
      container.setAttribute('nodeLevel', 0, 0);

      if (container.firstChild)
      {
        setNodeLevelAttr(container.firstChild, 1);
      }
    }

    return structure;
  };


  this.addClassName = (element, classNameToAdd) =>
  {
    if (!element || this.containsClassName(element, classNameToAdd)) { return; }

    if (element.classList)
    {
      element.classList.add(classNameToAdd);
      return;
    }

    const classNames = element.className.split(/\s+/);

    classNames.push(classNameToAdd);
    element.className = classNames.join(' ');
  };


  this.removeClassName = (element, classNameToRemove) =>
  {
    if (!element) { return; }

    if (element.classList)
    {
      element.classList.remove(classNameToRemove);
      return;
    }

    let i,
        classNames = element.className.split(/\s+/),
        pos = -1;

    for (i = 0; i < classNames.length; i++)
    {
      if (classNames[i] === classNameToRemove) { pos = i; break; }
    }

    if (pos !== -1)
    {
      classNames.splice(i, 1);
      element.className = classNames.join(' ');
    }
  };


  this.containsClassName = (element, className) =>
  {
    if (!element) { return false; }

    if (element.classList) { return element.classList.contains(className); }

    return element.className.split(/\s+/).indexOf(className) >= 0;
  };
}